import type { ExternalSource } from '../../Analytics.types'
import GoogleAnalyticsIcon from './modules/GoogleAnalytics/assets/google-analytics-icon.svg'

export const externalSourceIcons: Record<ExternalSource, string> = {
  'google-analytics': GoogleAnalyticsIcon,
}
